export enum OrdersAssignedURLParams {
  VIEW = 'view',
  TAB = 'tab',
}

export enum OrdersAssignedStorageKeys {
  APPLIED_FILTERS = 'ordersAssigned_appliedFilters',
  VIEW_PARAM = `ordersAssigned_${OrdersAssignedURLParams.VIEW}`,
  EXPANDED_STATE = `ordersAssigned_expandedState`,
  TAB_PARAM = `ordersAssigned_${OrdersAssignedURLParams.TAB}`,
}
